import { Component, Input, OnInit } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { Utils } from 'app/utils/utils';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-change-indicator',
  templateUrl: './lex-change-indicator.component.html',
  styleUrls: ['./lex-change-indicator.component.scss'],
  standalone: false,
})
export class LexChangeIndicatorComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() old: number;
  @Input() new: number;
  @Input() decimal = 1;

  value: number;
  displayValue: string;
  icon: string;
  color: string;

  constructor() {}

  ngOnInit(): void {
    this.setValues();
  }

  private setValues(): void {
    this.value = Utils.round(this.new - this.old, this.decimal);

    const isIncrease = this.value > 0;

    this.displayValue = `${isIncrease ? '+' : ''}${this.value.toFixed(this.decimal)}`;

    if (!isIncrease) {
      this.icon = 'small_down_triangle_filled';
    } else {
      this.icon = 'small_up_triangle_filled';
    }

    if (isIncrease) {
      this.color = 'positive';
    } else if (this.value === 0) {
      this.color = 'neutral';
    } else {
      this.color = 'negative';
    }
  }
}
